<script setup>
import { WButton, WTextfield } from '@alice-health/wonderland-vue'
import { inject, ref } from 'vue'

import { useStore } from '@/wrappers/store'

const { mapActions } = useStore()
const { deleteMessage } = mapActions('pillars/channel/message')

const confirm = inject('confirm')
const notify = inject('notify')

const props = defineProps({
  channelId: { type: String, default: undefined }
})

const messageId = ref(undefined)

const deleteChannelMessage = async () => {
  if (!props.channelId || !messageId.value) {
    notify({
      description: 'É obrigatório informar o id do canal e o id da mensagem!',
      duration: 6000
    })

    return
  }

  const confirmed = await confirm({
    title: `Tem certeza que deseja remover a mensagem?`,
    description: `Essa ação vai remover a mensagem de id ${messageId.value} do canal de id ${props.channelId}`
  })

  if (!confirmed) return

  await deleteMessage({
    channelId: props.channelId,
    messageId: messageId.value
  })

  notify({
    description: `A mensagem de id <strong>${messageId.value}</strong> foi removida do canal de id <strong>${this.channelId}</strong>`,
    duration: 6000
  })
}
</script>

<template>
  <div class="debug-message__form">
    <WTextfield
      v-model="messageId"
      placeholder="Insira o messageId da mensagem que deseja excluir"
    />
    <WButton
      :disabled="!messageId"
      block
      contextual="primary"
      @click="deleteChannelMessage"
    >
      Excluir mensagem
    </WButton>
  </div>
</template>

<style lang="scss">
.debug-message__form {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: var(--gl-spacing-04);
  margin-top: var(--gl-spacing-04);
  margin-bottom: var(--gl-spacing-04);
}
</style>
